import { useAppSelector } from '@common/hooks'
import ModalWrapper from '@common/modals/ModalWrapper'

import ModalContent from './ModalContent'


interface IProps {
  onHide: () => void,
  onSubmit: () => Promise<unknown>,
  permissions: IPermissionKeyed[],
  show: boolean,
}

export default function PermissionConfirmationModal({
  onHide,
  onSubmit,
  permissions,
  show,
}: IProps): JSX.Element | null {
  const application = useAppSelector(store => store.application.data)
  if(!application) {
    return null
  }
  return <ModalWrapper
    show={show}
    component={ModalContent}
    permissions={permissions}
    size="lg"
    onHide={() => {
      onHide()
    }}
    onClose={() => {
      void onSubmit()
        .then(() => onHide())
    }}
  />
}
